// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"18e7d390","165":"ac731b4c","344":"28fe2a04","406":"7cc3e462","584":"9c997932","612":"85520ba6","663":"2f1690fc","736":"12040d8f","858":"739927c0","864":"7685fcc4","881":"ffa122ff"}[chunkId] + ".chunk.js";
};